module.exports = __webpack_public_path__ + "img/Manuel_Munios.23662d6f.jpg";